export const PoweredByGuidde = () => (
    <div style={{ marginRight: '2px' }}>
        <a
            href="https://www.guidde.com/"
            rel="noreferrer"
            target="_blank"
            style={{ textDecoration: 'none', color: '#000000' }}
        >
            Powered by <strong style={{ color: '#CB0000' }}>Guidde</strong>
        </a>
    </div>
)
